
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface AdvancedFieldsProps {
  form: UseFormReturn<any>;
}

export const AdvancedFields = ({ form }: AdvancedFieldsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="product"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Product</FormLabel>
            <FormControl>
              <Input {...field} placeholder="e.g. UMCBL" value={field.value || ""} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="verified_since"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Verified Since</FormLabel>
            <FormControl>
              <Input type="date" {...field} value={field.value || ""} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="expected_monthly_profit"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Expected Monthly Profit (%)</FormLabel>
            <FormControl>
              <Input type="number" step="0.01" {...field} placeholder="e.g. 5.25" value={field.value || ""} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="defined_max_drawdown"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Defined Max Drawdown (%)</FormLabel>
            <FormControl>
              <Input type="number" step="0.01" {...field} placeholder="e.g. 15.00" value={field.value || ""} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
